module.exports = __webpack_public_path__ + "img/slika53.b1493da9.jpg";